import { apiRequest } from "./apiRequest";

export const importCompetitorUrlsFromCSV = async (
  websiteId: number,
  file: File,
) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await apiRequest(
      "post",
      `/export-csv/import-competitor-urls-from-csv/${websiteId}`,
      {
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return response;
  } catch (error) {
    console.error("CSV upload failed", error);
    throw error;
  }
};
